export const PatientSteps = [
  'Doctor',
  'Account',
  'Plan',
  'Prescription',
  'Address',
  'Review',
  'Payment',
];

export const PatientStepsHeader = {
  DOCTOR: '1. Select Doctor',
  REGISTER: '2. Create Patient Account',
  PLAN: '3. Select Patient Plan',
  PRESCRIPTION: '4. Add Patient Prescription',
  SHIPPING: '5. Add Shipping Address',
  BILLING: 'Add Billing Address',
  REVIEW: '6. Review',
  PAYMENT: '7. Payment',
};
